import { render, staticRenderFns } from "./nxBottomDownload.vue?vue&type=template&id=8cd33896&scoped=true&"
import script from "./nxBottomDownload.vue?vue&type=script&lang=js&"
export * from "./nxBottomDownload.vue?vue&type=script&lang=js&"
import style0 from "./nxBottomDownload.vue?vue&type=style&index=0&id=8cd33896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd33896",
  null
  
)

export default component.exports